import type { FAQAccordionBlock as FAQAccordionBlockType } from '@/shared/types/blocks';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/shared/ui/accordion';

/**
 * FAQAccordionBlock - FAQ 전용 아코디언
 *
 * Figma 디자인 기준 (5079-8602, 5079-8605):
 * - 질문: label-large-b (18px Bold, 1.35lh), black, py-6 (24px)
 * - 답변: label-medium (16px Regular, 1.35lh), label-intermediate, pt-2 pb-6 (8px/24px)
 * - 컨테이너: px-2 (8px), border-b border-label-weakest (#d9dde0)
 */
export function FAQAccordionBlock({
  items,
  defaultOpen,
}: Omit<FAQAccordionBlockType, 'type' | 'id'>) {
  const defaultDesc = defaultOpen !== undefined ? `faq-${defaultOpen}` : undefined;

  return (
    <Accordion type="single" collapsible defaultValue={defaultDesc}>
      {items.map((faq, index) => (
        <AccordionItem
          key={`${faq.question}-${index}`}
          value={`faq-${index}`}
          className="border-b border-label-weakest px-2"
        >
          <AccordionTrigger className="label-large-b text-black py-6">
            {faq.question}
          </AccordionTrigger>
          <AccordionContent className="label-medium text-label-intermediate pt-2 pb-6 px-0">
            {faq.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
